import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
const MailingStatsSkeleton = memo(function MailingStatsSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="bg-skeleton-primary animate-pulse rounded-sm text-transparent">.</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
});
export default MailingStatsSkeleton;